<template>
	<div class="pageContainer app-container">
		<el-row>
			<el-col :span="24">
				<el-form :inline="true" :model="EditItem" style="margin-top: 10px;">
					<el-form-item>
						<el-button type="primary" @click="add">添加批次</el-button>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
		<el-table :data="DataList" stripe border>
			<el-table-column type="index" label="编号" width="80">
			</el-table-column>
			<el-table-column prop="pc_name" label="批次名称" min-width="120">

			</el-table-column>
			<el-table-column prop="fsdate" label="开始时间" width="200">
			</el-table-column>
			<el-table-column prop="fedate" label="结束时间" width="200">
			</el-table-column>

			<el-table-column fixed="right" label="操作" width="150">
				<template slot-scope="scope">

					<el-button type="text" @click="update(scope.row)">编辑</el-button>
					<el-button type="text" @click="remove(scope.row.id)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<el-dialog title="编辑招生批次" :visible.sync="dialogVisible" :close-on-click-modal="false">


			<el-form :model="EditItem" ref="EditItem" label-width="120px">

				<el-row style="padding-top: 20px;">
					<el-col :span="20">
						<el-form-item label="批次名称">
							<el-input v-model="EditItem.pc_name" placeholder="批次名称"></el-input>

						</el-form-item>

					</el-col>
					<el-col :span="10">
						<el-form-item label="开始时间">
							<el-date-picker value-format="MMdd" style="width: 100%;" v-model="EditItem.sdate"
								placeholder="开始时间"></el-date-picker>

						</el-form-item>

					</el-col>
					<el-col :span="10">
						<el-form-item label="结束时间">
							<el-date-picker value-format="MMdd" style="width: 100%;" v-model="EditItem.edate"
								placeholder="结束时间"></el-date-picker>

						</el-form-item>

					</el-col>


				</el-row>


			</el-form>
			<el-row>
				<el-col :span="22" style="text-align: right;">
					<el-button type="primary" @click="saveForm">保存</el-button>
				</el-col>
			</el-row>
		</el-dialog>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				dialogVisible: false,
				EditItem: {

					pc_name: '',
					id: 0,
					sdate: "",
					edate: ""
				},
				DataList: [],

			}
		},
		mounted() {
			this.getList();
		},
		methods: {
			getList() {
				this.$http.post("/api/t_sch_pici_list", {
					page: 1,
					pagesize: 100
				}).then(res => {
					for(let item of res.data.data){
						item.fsdate = item.sdate.slice(0, 2) + "月" + item.sdate.slice(2)+"日";
						item.fedate = item.edate.slice(0, 2) + "月" + item.edate.slice(2)+"日";
						
					}
					this.DataList = res.data.data
				})
			},
			update(item) {
				this.dialogVisible = true
				item.status = item.status ? true : false
				this.EditItem = item;
			},
			uploadCover(e) {

				this.EditItem.image = e.src
			},
			add() {
				this.EditItem = {
					pc_name: '',
					id: 0,
					sdate: "",
					edate: ""
				}
				this.dialogVisible = true
			},
			remove(id) {
				this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post("/api/t_sch_pici_delete", {
						id: id
					}).then(res => {
						this.$message({
							type: 'success',
							message: '删除成功'
						});

						this.getList();
					})

				}).catch(() => {

				});
			},
			saveForm() {
				if (this.EditItem.id > 0) {
					this.$http.post("/api/t_sch_pici_edit", this.EditItem).then(res => {
						this.$message({
							type: 'success',
							message: '保存成功'
						});
						this.dialogVisible = false
						this.getList();
					})
				} else {

					this.$http.post("/api/t_sch_pici_edit", this.EditItem).then(res => {
						this.$message({
							type: 'success',
							message: '保存成功'
						});
						this.dialogVisible = false
						this.getList();
					})
				}
			}
		}
	}
</script>

<style scoped>

</style>
